import { ResolverTag } from '@ps/web-core-enums';
import { canUseDOM } from '@ps/web-core-utils';
import { StarsButton, useNavigate, useResolver } from '@ps/web-shared-components';
import React from 'react';
import { useDispatch } from 'react-redux';

import type { Dispatch } from '@swf/core/store';

import { TXTWCL_Browse_tournaments } from './TournamentMoneyPokerContent.messages.json';
import styles from './TournamentMoneyPokerContent.scss';

interface Props {
  isEmbedded: boolean;
}

const TournamentMoneyPokerContent: React.FC<Props> = ({ isEmbedded }) => {
  const { modal } = useDispatch<Dispatch>();
  const tournamentTicketsLink = useResolver(ResolverTag.TournamentTicketsLobby);
  const navigate = useNavigate();
  const browseTournaments = () => {
    if (isEmbedded && canUseDOM) {
      window.starsweb?.app.execute('lobby/tourney/all');
    } else {
      const tournamentTicketsPath = tournamentTicketsLink
        ? new URL(tournamentTicketsLink).pathname.replace('//', '/')
        : '';
      navigate(tournamentTicketsPath);
      modal.close();
    }
  };

  return (
    <StarsButton
      className={styles.button}
      block
      type="button"
      onClick={browseTournaments}
      translation={TXTWCL_Browse_tournaments}
    />
  );
};
export default TournamentMoneyPokerContent;
